import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Loader from '../../../components/Loader';
import styles from './option.scss';

const propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  description: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
};

const Option = ({
  icon,
  title,
  onClick,
  description,
  children,
  disabled,
  className,
  href,
  loading,
}) => {
  const body = (
    <>
      { icon
        && (
        <div className={styles.icon}>
          <i className={`far fa-${icon}`} />
          <div className={styles.iconBg}>
            <i className={`far fa-${icon}`} />
          </div>
        </div>
        )}
      <div className={styles.text}>
        <div className={styles.title}>
          {title}
        </div>
        <div className={styles.description}>
          {description}
          {children}
        </div>
      </div>
    </>
  );

  return href ? (
    <a
      className={classNames(
        styles.option,
        {
          [styles.disabled]: disabled,
          [className]: true,
        },
      )}
      href={!disabled ? href : undefined}
      rel="noopener noreferrer"
      target="_blank"
    >
      {body}
      <div className={styles.caret}>
        <i className="far fa-external-link" />
      </div>
    </a>
  ) : (
    <div
      role="button"
      tabIndex={0}
      className={classNames(
        styles.option,
        {
          [styles.disabled]: disabled || loading,
          [styles.unclickable]: disabled || !onClick,
          [className]: true,
        },
      )}
      onClick={onClick}
    >
      {body}
      { onClick && !loading && (
        <div className={styles.caret}>
          <i className="far fa-chevron-right" />
        </div>
      )}
      { loading && (
        <div className={styles.loading}>
          <Loader loading />
        </div>
      )}
    </div>
  );
};

Option.propTypes = propTypes;

export default Option;
